import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import { DashboardService } from "@/api";

const onDefaultError = (err) => {
  toast.error(err.response.data.message);
};

const useGetDashboardCounts = (onSuccess, onError = onDefaultError) => {
  return useQuery({
    queryKey: ["dashboard-count"], // slug in the query key
    queryFn: () => DashboardService.getCounts(), // Pass slug directly
    onSuccess, // Success callback
    onError, // Error callback,
    retry: false,
  });
};

const useGetUserChart = (params, onSuccess, onError = onDefaultError) => {
  return useQuery({
    queryKey: ["dashboard-user-chart", params], // Cache key for query
    queryFn: () => DashboardService.getUserChart(params), // Pass slug directly
    onSuccess, // Success callback
    onError, // Error callback,
    retry: false,
  });
};

export { useGetDashboardCounts, useGetUserChart };
